import { useMutation } from "@tanstack/react-query"
import { OEBackend } from "@/graphql"
import { useGraphQLClient } from "@/lib/blueprint-auth/client"

const RunEstimatedAnnualConsumptionAnalysisMutation = OEBackend.graphql(`
    mutation RunEstimatedAnnualConsumptionAnalysisMutation($input: RunEstimatedAnnualConsumptionAnalysisInput!) {
        runEstimatedAnnualConsumptionAnalysis(input: $input) {
            token
            unavailableReason
            annualConsumptionByTemporalClass {
                temporalClass
                consumptionKwh
            }
        }
    }
`)

type RunEstimatedAnnualConsumptionAnalysisInput = {
    meterPointId: string
    firstName: string
    lastName: string
}

export function useRunEstimatedAnnualConsumptionAnalysis() {
    const oeGraphQLClient = useGraphQLClient({ target: "oeBackend" })

    return useMutation({
        mutationFn: async (input: RunEstimatedAnnualConsumptionAnalysisInput) => {
            const { runEstimatedAnnualConsumptionAnalysis: analysis } =
                await oeGraphQLClient.request(RunEstimatedAnnualConsumptionAnalysisMutation, {
                    input: { consentLevel: "CURRENT_OCCUPIER", ...input },
                })

            return {
                token: analysis.token,
                unavailableReason: analysis.unavailableReason,
                consumption:
                    analysis.annualConsumptionByTemporalClass?.map(
                        ({ temporalClass, consumptionKwh }) => ({
                            temporalClass,
                            consumption: consumptionKwh,
                        })
                    ) ?? null,
            }
        },
    })
}
